// const MIN_LENGTH_PASSWORD = 8;
// const MAX_LENGTH_PASSWORD = 40;

import { AuthError } from '~/services/auth';

const strongPassword = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/;
const mediumPassword =
    /((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,}))|((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{8,}))/;

export function strengthChecker(password: string) {
    let color;
    let type;
    if (strongPassword.test(password)) {
        // color = accent_color.success;
        type = 'strong';
    } else if (mediumPassword.test(password)) {
        // color = accent_color.error;
        type = 'medium';
    } else {
        // color = accent_color.warning;
        type = 'weak';
    }
    return { color, type };
}

export function errorMessage(errorCode: AuthError) {
    switch (errorCode) {
        case AuthError.MISSING_EMAIL:
            return "Email can't be empty";
        case AuthError.MISSING_PASSWORD:
            return "Password can't be empty";
        case AuthError.INVALID_EMAIL:
            return 'Invalid email';
        case AuthError.WRONG_PASSWORD:
            return 'Wrong password';
        case AuthError.USER_NOT_FOUND:
            return 'User not found';
        case AuthError.TOO_MANY_REQUESTS:
            return 'Too many requests';
        case AuthError.USER_MISMATCH:
            return 'User mismatch';
        case AuthError.EMAIL_ALREADY_IN_USE:
            return 'Email already in use';
        case AuthError.WEAK_PASSWORD:
            return 'Weak password';
        case AuthError.PASSWORDS_DONT_MATCH:
            return "Passwords don't match";
        default:
            return 'Unknown error';
    }
}
